<!--  -->
<template>
  <div>
    <news-show :plates="plates" v-if="plates.length>0" />
    <center-model :plates="plates" v-if="plates.length>0"/>
    <div class="clear"></div>
    <div class="allbox"></div>
    <div class="clear"></div>
    <div class="courseBox">
      <MyCourse/>
      <exam-center/>
      <course-center/>
     
   </div>
  </div>
</template>

<script>
//
import CenterModel from "@/components/HomeComs/CenterModel_M.vue";
import ExamCenter from "@/components/HomeComs/ExamCenter_M.vue";
import NewsShow from "@/components/HomeComs/NewsShow_M.vue";
import CourseCenter from "../components/HomeComs/CourseCenter_M.vue";
import MyCourse from '../components/HomeComs/MyCenter_M.vue';

export default {
  data() {
    return {};
  },
  props: {
    plates: Array,
  },
  components: { NewsShow, CenterModel, ExamCenter, CourseCenter, MyCourse },

  mounted() {},

  methods: {},
};
</script>
<style  lang="scss" scoped>
  @import "@/assets/css/style_Phone.scss";
</style>
